import { render, staticRenderFns } from "./Banners.vue?vue&type=template&id=fb8ffb8a&"
import script from "./Banners.vue?vue&type=script&lang=js&"
export * from "./Banners.vue?vue&type=script&lang=js&"
import style0 from "./Banners.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAppBar,VCard,VIcon})
